import Modal from '@/components/modules/Modal';
import { ReactNode, useRef } from 'react';

export const DismissableModal = ({
  modalKey,
  children,
}: {
  modalKey: string;
  children: ReactNode;
}) => {
  const rootRef = useRef(null);
  return (
    <Modal size="xl" modalKey={modalKey} clickOffToClose>
      <div ref={rootRef}>{children}</div>
    </Modal>
  );
};
